const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M320,138.938V0H192v138.938C117.438,165.297,64,236.406,64,320c0,106.031,85.969,192,192,192 c106.047,0,192-85.969,192-192C448,236.406,394.578,165.297,320,138.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M341.344,32c0,17.672-14.328,32-32,32H202.672c-17.672,0-32-14.328-32-32l0,0 c0-17.688,14.328-32,32-32h106.672C327.016,0,341.344,14.312,341.344,32L341.344,32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC92EC"
    },
    d: "M256,512c106.047,0,192-85.969,192-192c0-15.094-1.75-29.75-5.031-43.844 c-9.922,27.469-30.969,52.484-60.609,68.312c-18.109,9.656-35.203,13.906-51.641,13.906c-36.344,0-69.406-20.812-102.844-49.844 c-30.703-26.656-65.984-49-104.5-49c-16.125,0-32.828,3.922-50,13.094c-1.359,0.719-2.703,1.469-4.031,2.25 C65.859,289.344,64,304.453,64,320C64,426.031,149.969,512,256,512z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.ea80ae19f298904d852df95600bfafa5.svg";
export { ForwardRef as ReactComponent };